var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "box" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _c("table", [
        _c("tr", [
          _c("td", { staticStyle: { width: "100%" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.scanText,
                  expression: "scanText"
                }
              ],
              staticClass: "textfield",
              attrs: { id: "scanText", tabindex: "0" },
              domProps: { value: _vm.scanText },
              on: {
                change: _vm.scan,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.scanText = $event.target.value
                }
              }
            })
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "nav-bar" }, [
      _c(
        "div",
        _vm._l(_vm.nav_items, function(item, index) {
          return _vm.perms.includes(_vm.nav_item_perms[index])
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.button(item)
                    }
                  }
                },
                [_vm._v(_vm._s(item))]
              )
            : _vm._e()
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Scan")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40e66512", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40e66512","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/add/Add_Inventory_Item.vue
// module id = 666
// module chunks = 0